<button mat-icon-button [matMenuTriggerFor]="menuInfo" class="se-header-toolbar-button">
    <mat-icon>help_outline</mat-icon>
</button>
<mat-menu #menuInfo="matMenu" yPosition="below" xPosition="before" color='primay' class="se-mat-menu">
    <button mat-menu-item (click)="onHelpClick()" class="se-header-toolbar-item-info se-menu-button">
        <mat-icon>help</mat-icon>
        <span translate>Help</span><span>...</span>
    </button>
    <button mat-menu-item (click)="onViewerInfo()" class="se-header-toolbar-item-info se-menu-button">
        <mat-icon>desktop_windows</mat-icon>
        <span translate>Viewers</span><span>...</span>
    </button>
    <button mat-menu-item (click)="onClientInfo()" class="se-header-toolbar-item-info se-menu-button">
        <mat-icon>info</mat-icon>
        <span translate>About</span><span> Suitestensa...</span>
    </button>
</mat-menu>
